import BanksLanding from './BanksLanding'

export default BanksLanding
